module.exports = __webpack_public_path__ + "img/logo_legisla.ce2bd318.png";